/**
 * The company in departments (v0.1.150, Ekip › Organizasyon): GET /team/organization. Seven departments from
 * twin.departments, each with its manager and staff (agents whose department matches, and the people who work
 * there); Denetim is independent and answers to Sercan. A role that is not switched on yet is "planned": it is on
 * the chart, it does not run.
 */
import { z } from 'zod';
export const ORG_MEMBER_STATES = ['working', 'ready', 'paused', 'planned', 'human'];
export const orgMemberSchema = z.strictObject({
    /** An agent id or a human id (the Kişi page takes either). */
    id: z.string(),
    kind: z.enum(['agent', 'human']),
    name: z.string(),
    /** Short role ("Departman müdürü", "Pazar ve rakip araştırması"). */
    role: z.string(),
    /** What the role does, in Turkish. */
    duty: z.string().nullable(),
    state: z.enum(ORG_MEMBER_STATES),
    /** How it works: a Claude or Genesis agent, a Vertex agent, code; null for a person. */
    runtime: z.enum(['claude', 'genesis', 'vertex', 'code']).nullable(),
    reportsTo: z.string().nullable(),
});
export const orgDepartmentSchema = z.strictObject({
    code: z.string(),
    name: z.string(),
    purpose: z.string(),
    /** Denetim answers to Sercan, not to the Genel Müdür. */
    independent: z.boolean(),
    manager: orgMemberSchema.nullable(),
    members: z.array(orgMemberSchema),
});
export const organizationViewSchema = z.strictObject({
    asOf: z.number(),
    departments: z.array(orgDepartmentSchema),
});
//# sourceMappingURL=organization.js.map